import { useContext, useEffect, useRef, useState } from "react";
import $ from "jquery";
import { CardIcon } from "../../../../Layout/Common/CardIcon";
import { cardExpiryError, cardMonthYear, isAlpha, isNumberOnly, showCardDetails } from "../../../../Layout/Common/common";
import { faCommentsDollar } from "@fortawesome/free-solid-svg-icons";
import { GlobalContext } from "../../../../Context/GlobalContext";
import { useAuth } from "../../../../Context/AuthContext";
import { useLoginModal } from "../../../../Context/LoginModalContext";
import { takeCardReentryNotice } from "../../../../Context/hook/tillRedirect";
var Textstyle = {
  display: "block",
  width: "100%",
  height: "42px",
  padding: ".375rem .75rem",
  fontSize: "1rem",
  lineHeight: "1.5",
  color: "#212529",
  backgroundColor: "#ffffff",
  backgroundImage: "none",
  backgroundClip: "padding-box",
  border: "1px solid #dee2e6",
  borderRadius: "0.375rem",
  transition: "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
  appearance: "none",
};

const PlaceholderStyle = {
  color: "#999999",
  fontSize: "1rem",
};

export const NewCardPayment = ({ handleOnCheck, defaultCheck, allowSaveCard = true }) => {
  const { newcardName, newcardExp, setNewcardName, setNewcardExp, newCardSave, setNewcardSave, selectedPaymentType } =
    useContext(GlobalContext);
  const reentryRef = useRef(null);
  if (reentryRef.current === null) reentryRef.current = takeCardReentryNotice();
  const restoredFromTill = reentryRef.current;

  const [expiry, setExpiry] = useState(() => (restoredFromTill ? newcardExp || "" : ""));
  const [cardHolder, setCardHolder] = useState(() => (restoredFromTill ? newcardName || "" : ""));
  const [touched, setTouched] = useState({
    cardName: false,
    cardNameError: false,
    cardExp: false,
    cardExpError: false,
  });
  const { isAuthenticated } = useAuth();
  const { showLoginModal } = useLoginModal();
  const [pendingSaveCard, setPendingSaveCard] = useState(false);

  useEffect(() => {
    initcard();
  }, []);

  useEffect(() => {
    try {
      if (selectedPaymentType && selectedPaymentType === "NEWCARD") {
        $(".card-details-list1").show("slow");
        $(".acc-details-list1").hide("slow");
      } else {
        $(".card-details-list1").hide("slow");
      }
    } catch (e) {
      console.error(e);
    }
  }, [selectedPaymentType]);

  useEffect(() => {
    $("#newcardNameError").css("display", touched.cardNameError == true ? "block" : "none");

    $("#newcardExpError").css("display", touched.cardExpError == true ? "block" : "none");
  }, [touched]);

  useEffect(() => {
    setNewcardName(cardHolder);
    setNewcardExp(expiry);
  }, [expiry, cardHolder]);

  const initcard = () => {
    try {
      window.till = new window.PaymentJs();
      window.till.init(process.env.REACT_APP_TILL, "card_Number", "card_Cvv", function (p) {
        p.setNumberStyle(Textstyle);
        p.setCvvStyle(Textstyle);
        p.setNumberPlaceholder("Enter Card Number", PlaceholderStyle);
        p.setCvvPlaceholder("Enter CVV", PlaceholderStyle);
      });
    } catch (err) {}
  };

  return (
    <div className={`choose-card payment-card-list shipPayment ${selectedPaymentType === "NEWCARD" ? "selected" : ""}`}>
      <div className="shipping-method express-shipping">
        <div className="shipping-method-info pay-option" data-group={1} data-type="card" id="pay-card">
          <div>
            <input
              className="form-check-input"
              type="radio"
              name="paymentMethod"
              id="newCardPayment"
              value="NEWCARD"
              onChange={() => {
                handleOnCheck("NEWCARD");
              }}
              onClick={() => {
                handleOnCheck("NEWCARD");
              }}
              checked={selectedPaymentType == "NEWCARD"}
            />
          </div>
          <label className="form-check-label" htmlFor="newCardPayment">
            <div
              className="full-width d-flex align-items-center"
              style={{ gap: "10px", minWidth: "50px" }}
              onClick={() => {
                handleOnCheck("NEWCARD");
              }}
            >
              <div className="pay-icon">
                <CardIcon cardType="cc-cards" alt="account" />
              </div>
              <div>Pay Online via Credit Card</div>
            </div>
          </label>
        </div>
      </div>
      <div className="card-details-list1" style={{ display: "none" }}>
        <div className="add-new-card">
          {restoredFromTill && (
            <p style={{ margin: "0 0 12px", fontSize: "13px", color: "#a15c00" }}>
              Your order details have been kept. For your security, please re-enter your card number and CVV.
            </p>
          )}
          <form>
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3 card-no-info">
                  <input
                    type="text"
                    className="form-control"
                    id="cardName"
                    aria-describedby=""
                    placeholder="Enter Name"
                    value={cardHolder}
                    onChange={(e) => {
                      let val = isAlpha(e.target.value);
                      setCardHolder(val);
                      setTouched((prev) => ({
                        ...prev,
                        cardNameError: val == "",
                      }));
                    }}
                  />
                  <div
                    id="newcardNameError"
                    className="text-danger form-validation-message"
                    style={{
                      display: "none",
                    }}
                  >
                    Cardholder Name is required
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3 card-no-info" style={{ display: "none" }}>
                  <input
                    type="text"
                    className="form-control"
                    id="cardNumber"
                    aria-describedby=""
                    placeholder="Enter Card Number"
                  />
                  <span className="wes-lock-cc" />
                </div>
                <div id="card_Number" className="mb-3 card-no-info" style={{ height: "44px", padding: 0 }}></div>
              </div>
              <div className="col-md-6">
                <div className="mb-3 card-no-info">
                  <input
                    type="text"
                    className="form-control"
                    id="cardExp"
                    aria-describedby=""
                    placeholder="Expiration date (MM/YY)"
                    value={expiry}
                    onChange={(e) => {
                      let val = cardMonthYear(e.target.value);
                      setExpiry(val);
                      setTouched((prev) => ({
                        ...prev,
                        cardExpError: val === "" || (val.length === 5 && cardExpiryError(val) !== ""),
                      }));
                    }}
                  />
                  <div
                    id="newcardExpError"
                    className="text-danger form-validation-message"
                    style={{
                      display: touched.cardExpError ? "block" : "none",
                    }}
                  >
                    {cardExpiryError(expiry)}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3 card-no-info" style={{ display: "none" }}>
                  <input
                    type="text"
                    className="form-control"
                    id="cardCvv"
                    aria-describedby=""
                    placeholder="Security Code"
                  />
                  <span className="wes-info-cc" />
                </div>
                <div id="card_Cvv" style={{ height: "44px", padding: 0 }}></div>
              </div>
            </div>
            <div
              className="form-check custom-check feature-order"
              style={{ display: allowSaveCard ? "flex" : "none", gap: "4px", alignItems: "center" }}
            >
              <input
                className="form-check-input"
                type="checkbox"
                id="savecard"
                checked={newCardSave}
                onChange={(e) => {
                  const checked = e.target.checked;
                  if (checked && !isAuthenticated) {
                    setNewcardSave(false);
                    showLoginModal();
                    return;
                  }
                  setNewcardSave(checked);
                }}
                style={{ marginTop: 0 }}
              />
              <label className="form-check-label" htmlFor="savecard" style={{ top: 0 }}>
                Save this card for features orders
              </label>
              <i className="fa-solid fa-circle-info" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
